import OnEditorEvent from "../OnEditorEvent";
import PropTypes from "prop-types";
import React from "react";

export default function MentionSelectionKeyboardOps({
  handleEscape,
  handleMoveToNext,
  handleMoveToPrevious,
  handleAcceptSuggestion,
}) {
  return (
    <OnEditorEvent
      onEscape={handleEscape}
      onDownArrow={handleMoveToNext}
      onUpArrow={handleMoveToPrevious}
      handleReturn={handleAcceptSuggestion}
      onTab={handleAcceptSuggestion}
    />
  );
}

MentionSelectionKeyboardOps.propTypes = {
  handleEscape: PropTypes.func.isRequired,
  handleMoveToNext: PropTypes.func.isRequired,
  handleMoveToPrevious: PropTypes.func.isRequired,
  handleAcceptSuggestion: PropTypes.func.isRequired,
};
